function A(r) {
  return r.map((i) => {
    const [n, o] = i.split(":");
    return {
      provider: n,
      accounts: [o]
    };
  }).reduce((i, n) => {
    const o = i.find((s) => s.provider === n.provider);
    return o ? o.accounts.push(...n.accounts) : i.push(n), i;
  }, []);
}
function P() {
  if (!(typeof navigator > "u"))
    return {
      os: T(),
      version: void 0,
      interaction_channel: /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? "web_mobile" : "web_desktop"
    };
}
function T() {
  const r = navigator.userAgent, e = navigator.platform;
  return /Windows NT 10.0/.test(r) ? "Windows 10" : /Windows NT 6.3/.test(r) ? "Windows 8.1" : /Windows NT 6.2/.test(r) ? "Windows 8" : /Windows NT 6.1/.test(r) ? "Windows 7" : /Mac OS X/.test(r) ? "macOS" : /Linux/.test(e) ? "Linux" : /iPhone|iPad|iPod/.test(r) ? "iOS" : /Android/.test(r) ? "Android" : "unknown";
}
function S() {
  return typeof navigator > "u" || !navigator.language ? "unknown" : navigator.language;
}
const c = {
  get items() {
    try {
      return JSON.parse(localStorage.getItem("observability-queued-actions") || "[]");
    } catch {
      return [];
    }
  },
  set items(r) {
    try {
      localStorage.setItem("observability-queued-actions", JSON.stringify(r));
    } catch {
      localStorage.setItem("observability-queued-actions", "[]");
    }
  },
  get first() {
    return c.items[0];
  },
  get last() {
    return c.items.at(-1);
  },
  dequeue: () => {
    const r = c.items[0];
    return c.items = c.items.slice(1), r;
  }
};
/*! js-cookie v3.0.5 | MIT */
function m(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var i in t)
      r[i] = t[i];
  }
  return r;
}
var I = {
  read: function(r) {
    return r[0] === '"' && (r = r.slice(1, -1)), r.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(r) {
    return encodeURIComponent(r).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function b(r, e) {
  function t(n, o, s) {
    if (!(typeof document > "u")) {
      s = m({}, e, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var u in s)
        s[u] && (a += "; " + u, s[u] !== !0 && (a += "=" + s[u].split(";")[0]));
      return document.cookie = n + "=" + r.write(o, n) + a;
    }
  }
  function i(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], s = {}, a = 0; a < o.length; a++) {
        var u = o[a].split("="), d = u.slice(1).join("=");
        try {
          var h = decodeURIComponent(u[0]);
          if (s[h] = r.read(d, h), n === h)
            break;
        } catch {
        }
      }
      return n ? s[n] : s;
    }
  }
  return Object.create(
    {
      set: t,
      get: i,
      remove: function(n, o) {
        t(
          n,
          "",
          m({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return b(this.converter, m({}, this.attributes, n));
      },
      withConverter: function(n) {
        return b(m({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(r) }
    }
  );
}
var _ = b(I, { path: "/" });
function U(r) {
  try {
    return r ? atob(r) : null;
  } catch {
    return null;
  }
}
const l = {
  read: (r) => {
    const e = _.get(r), t = new URLSearchParams(e);
    return {
      referrer: U(t.get("referrer")) || "",
      referring_domain: t.get("referring_domain") || "",
      utm_content: t.get("utm_content") || "",
      utm_term: t.get("utm_term") || "",
      utm_source: t.get("utm_source") || "",
      utm_medium: t.get("utm_medium") || "",
      utm_campaign: t.get("utm_campaign") || "",
      timestamp: Number(t.get("timestamp")) || 0,
      kueski_track_id: t.get("kueski_track_id") || "",
      merchant_id: t.get("merchant_id") || "",
      fbclid: t.get("fbclid") || "",
      gclid: t.get("gclid") || ""
    };
  },
  // TODO: Add a test to validate written cookie
  write: (r, e, t) => {
    const i = Object.entries(e).sort(([o], [s]) => o.localeCompare(s)), n = new URLSearchParams(i);
    e.referrer && n.set("referrer", btoa(e.referrer)), _.set(r, n.toString(), { domain: t, path: "/" });
  },
  clear: (r) => {
    _.remove(r);
  }
}, f = "attribution_timestamp", p = {
  get session() {
    return Number(window.sessionStorage.getItem(f)) || 0;
  },
  set session(r) {
    window.sessionStorage.setItem(f, String(r));
  },
  get local() {
    return Number(window.localStorage.getItem(f)) || 0;
  },
  set local(r) {
    window.localStorage.setItem(f, String(r));
  }
};
function O() {
  if (typeof window > "u") return !1;
  const r = p.local, e = p.session, t = l.read("kueski_attribution").timestamp;
  return !(!t || t === r && !e || r && t && t !== r && !e);
}
const C = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let R = (r = 21) => {
  let e = "", t = crypto.getRandomValues(new Uint8Array(r));
  for (; r--; )
    e += C[t[r] & 63];
  return e;
};
function x() {
  const r = globalThis.document ? globalThis.document.referrer : "", [e] = r.split("?");
  return e;
}
function E(r) {
  try {
    return new URL(r).hostname;
  } catch {
    return "";
  }
}
function v() {
  const r = globalThis.location ? globalThis.location.search : "", e = new URLSearchParams(r), t = x();
  return {
    kueski_track_id: R(36),
    referrer: t || "",
    referring_domain: E(t) || "",
    utm_content: e.get("utm_content") || "",
    utm_term: e.get("utm_term") || "",
    utm_campaign: e.get("utm_campaign") || "",
    utm_medium: e.get("utm_medium") || "",
    utm_source: e.get("utm_source") || "",
    fbclid: e.get("fbclid") || "",
    gclid: e.get("gclid") || "",
    merchant_id: "",
    timestamp: (/* @__PURE__ */ new Date()).getTime()
  };
}
function k(r) {
  p.local = r, p.session = r;
}
const w = "kueski_track_id", g = {
  get value() {
    return localStorage.getItem(w) || "";
  },
  set value(r) {
    localStorage.setItem(w, r);
  }
};
class L {
  constructor() {
    this.domain = "", this.providers = {};
  }
  get data() {
    return l.read("kueski_attribution");
  }
  set data(e) {
    l.write("kueski_attribution", e, this.domain);
  }
  sendAttribution(e = !1) {
    const t = l.read("kueski_attribution"), i = l.read("sended_attribution"), n = Object.keys(t).filter((d) => d !== "timestamp").some((d) => t[d] !== i[d]);
    if (!e && !n) return Promise.resolve([]);
    const o = Object.values(this.providers), { timestamp: s, ...a } = t, u = o.map((d) => d.updateAttribution(a));
    return l.write("sended_attribution", t, this.domain), Promise.all(u);
  }
  update({ forceNotify: e = !1, forceInvalidate: t = !1, ...i } = {}) {
    let n;
    if (!t && O()) {
      const o = v(), s = this.data;
      n = {
        kueski_track_id: s.kueski_track_id || g.value || o.kueski_track_id,
        referrer: s.referrer || o.referrer,
        referring_domain: s.referring_domain || o.referring_domain,
        utm_content: o.utm_content || s.utm_content,
        utm_term: o.utm_term || s.utm_term,
        utm_campaign: o.utm_campaign || s.utm_campaign,
        utm_medium: o.utm_medium || s.utm_medium,
        utm_source: o.utm_source || s.utm_source,
        fbclid: o.fbclid || s.fbclid,
        gclid: o.gclid || s.gclid,
        merchant_id: s.merchant_id || o.merchant_id,
        timestamp: s.timestamp || o.timestamp,
        ...i
      };
    } else {
      const { kueski_track_id: o, ...s } = v();
      n = {
        ...s,
        kueski_track_id: g.value || o,
        ...i
      };
    }
    return g.value = n.kueski_track_id, this.data = n, k(n.timestamp), this.sendAttribution(e);
  }
  clear() {
    return g.value = "", l.clear("kueski_attribution"), k(0), this.sendAttribution(!0);
  }
}
const j = new L();
class D {
  constructor() {
    this._callbacks = {};
  }
  addEventListener(e, t) {
    return this._callbacks[e] || (this._callbacks[e] = []), this._callbacks[e].push(t), this;
  }
  removeEventListener(e, t) {
    if (!this._callbacks[e]) return;
    const i = this._callbacks[e].indexOf(t);
    return i !== -1 && this._callbacks[e].splice(i, 1), this;
  }
  dispatchEvent(e, t) {
    if (this._callbacks[e]) {
      for (const i of this._callbacks[e])
        try {
          i(t);
        } catch {
        }
      return this;
    }
  }
}
function y({ targets: r, track: e }) {
  return {
    targets: r,
    track: async (t) => {
      const i = t.providers.filter(({ provider: n }) => r.includes(n));
      i.length !== 0 && await e({
        ...t,
        providers: i
      });
    }
  };
}
function M(r) {
  return y({
    targets: ["ga"],
    track: async (e) => {
      const { name: t, ...i } = e.action, n = {
        ...e.custom_attributes,
        ...e.properties,
        ...e.metadata,
        ...i,
        event: t
      };
      return r.push(n), Promise.resolve();
    }
  });
}
function W({ apiKey: r, apiUrl: e }) {
  return y({
    targets: ["amplitude", "braze"],
    track: async (t) => {
      const i = await globalThis.fetch(`${e}/api/v1/track`, {
        method: "POST",
        body: JSON.stringify(t),
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": r
        }
      });
      if (i.status < 200 || i.status >= 300) {
        const n = await i.text();
        throw new Error(`[Observability API failed with status ${i.status}]: ${n}`);
      }
    }
  });
}
class q {
  constructor() {
    this.config = null, this.logger = new D(), this._providers = [];
  }
  init(e) {
    this.config = e, this._providers = [
      W({ apiKey: e.apiKey, apiUrl: e.apiUrl }),
      e.dataLayer && M(e.dataLayer)
    ].filter(Boolean);
  }
  get enabled() {
    return this.config && typeof this.config.enabled == "boolean" ? this.config.enabled : !0;
  }
  set enabled(e) {
    this.config && (this.config.enabled = e);
  }
  identifyUser(e) {
    if (this.config)
      return this.config.userProperties = e, this.flushActions();
  }
  track(e, t) {
    if (!this.enabled) return console.log("not enabled");
    try {
      const i = j.data, n = i.utm_campaign || i.utm_medium || i.utm_source, o = i.referrer || i.referring_domain, s = t.target instanceof Array ? t.target : [t.target], a = {
        action: {
          name: e,
          ...t.attributes
        },
        custom_attributes: t.customAttributes,
        properties: {
          utm: n ? {
            campaign: i.utm_campaign,
            medium: i.utm_medium,
            source: i.utm_source
          } : void 0,
          referral: o ? {
            domain: i.referring_domain,
            name: i.referrer
          } : void 0,
          visitor: t.visitor,
          error: t.error
        },
        partialMetadata: {
          product: t.product || (this.config ? this.config.defaultProduct : void 0),
          time: Date.now()
        },
        providers: A(s)
      };
      return c.items = [
        ...c.items,
        a
      ], this.flushActions();
    } catch (i) {
      this.logger.dispatchEvent("log", {
        level: "error",
        config: this.config ? {
          ...this.config,
          dataLayer: void 0
          // prevent send datalayer as log
        } : null,
        message: (i || {}).message || "Failed to track",
        method: "track",
        actionName: e,
        actionOptions: t
      });
    }
  }
  async flushActions() {
    try {
      if (!this.enabled || !c.first) return;
      const e = this._getActionMetadata(c.first.action);
      if (!e) return;
      const t = c.dequeue();
      if (!t) return;
      const i = {
        action: t.action,
        custom_attributes: t.custom_attributes,
        properties: t.properties,
        providers: t.providers,
        metadata: {
          ...e,
          ...t.partialMetadata
        }
      };
      await Promise.all(this._providers.map((n) => n.track(i))), await this.flushActions();
    } catch (e) {
      this.logger.dispatchEvent("log", {
        level: "error",
        config: this.config ? {
          ...this.config,
          dataLayer: void 0
          // prevent send datalayer as log
        } : null,
        message: (e || {}).message || "Failed to flush actions",
        method: "flushActions"
      });
    }
  }
  // Return action metadata or null if not ready to track
  _getActionMetadata(e) {
    const t = this.config;
    return !t || !t.userProperties || !t.userProperties.id ? null : (t.userProperties.id || this.logger.dispatchEvent("log", {
      action: e,
      level: "warn",
      method: "_getActionMetadata",
      config: this.config ? {
        ...this.config,
        dataLayer: void 0
        // prevent send datalayer as log
      } : null,
      message: "User id is not valid"
    }), {
      device: P(),
      product: t.defaultProduct,
      language: S(),
      app_version: t.appVersion,
      user_properties: {
        id: t.userProperties.id,
        email: t.userProperties.email,
        name: t.userProperties.name || "",
        last_name: t.userProperties.last_name || void 0,
        birth_date: t.userProperties.birth_date || void 0,
        second_last_name: t.userProperties.second_last_name || void 0
      }
    });
  }
}
const B = new q();
typeof globalThis > "u" && typeof window < "u" && (window.globalThis = global);
export {
  j as kueskiAttribution,
  B as tracker
};
//# sourceMappingURL=main.js.map
